<div>
  <nz-tabset [(nzSelectedIndex)]="tabIndex" nzSize="large">
    <nz-tab [nzTitle]="'word.house' | translate">
      <div class="pt-[30px]">
        <nz-alert *ngIf="!isMultiInventory" nzShowIcon [nzMessage]="msgTpl" class="mb-6">
          <ng-template #msgTpl>
            <span>{{ "component.relate.single_stock" | translate }}</span>
            <a [href]="docLink">{{ "channel.know_about_house_relate" | translate }}</a>
          </ng-template>
        </nz-alert>
        <!-- <div *ngIf="!isMultiInventory" class="mb-6 text-xs">
          <i nz-icon nzType="exclamation-circle" nzTheme="outline" class="mr-2"></i>

        </div> -->
        <host-house-picker-v3_4
          mode="single"
          [emitValue]="true"
          (onChange)="onSelectHouse($event, 'house')"
        ></host-house-picker-v3_4>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'word.house_type' | translate">
      <div class="pt-[30px]">
        <nz-alert *ngIf="isMultiInventory" nzShowIcon [nzMessage]="typeMsgTpl" class="mb-6">
          <ng-template #typeMsgTpl>
            <span>{{ "component.relate.inventory_limit_greater_than_one" | translate }}</span>
            <a [href]="docLink">{{ "channel.know_about_house_relate" | translate }}</a>
          </ng-template>
        </nz-alert>
        <!-- <div *ngIf="isMultiInventory" class="mb-6 text-xs">
          <i nz-icon nzType="exclamation-circle" nzTheme="outline" class="mr-2"></i>
          <span>{{ "component.relate.inventory_limit_greater_than_one" | translate }}</span>
          <a [href]="docLink">{{ "channel.know_about_house_relate" | translate }}</a>
        </div> -->
        <host-house-type-picker-v3_4
          mode="single"
          [emitValue]="true"
          (onChange)="onSelectHouse($event, 'type')"
        ></host-house-type-picker-v3_4>
      </div>
    </nz-tab>
  </nz-tabset>
</div>
